module.exports = __webpack_public_path__ + "static/img/img_0431.331c542.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0431.jpg
// module id = ppP/
// module chunks = 0